import { RefObject, useCallback, useImperativeHandle, useState } from "react";

import { IconButton, Modal, Tooltip } from "@mui/material";
import { IoClose } from "react-icons/io5";

import "./image_viewer.scss";

export type TVideoViewerProps = {
	ref: RefObject<TVideoViewerRef | null>;
};
export type TVideoViewerRef = {
	open: ({ url }: { url: string }) => void;
	close: () => void;
};

export function VideoViewer(props: TVideoViewerProps) {
	const [isOpen, setIsOpen] = useState(false);
	const [url, setUrl] = useState("");

	const open = useCallback(({ url: imageUrl }: { url: string }) => {
		setUrl(imageUrl);
		setIsOpen(true);
	}, []);

	const close = () => {
		setIsOpen(false);
	};

	useImperativeHandle(props.ref, () => ({ open, close }), [open]);

	const onClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
		if (reason === "escapeKeyDown") {
			close();
		}
	};

	const renderMedia = () => {
		if (!url) {
			return null;
		}

		return (
			<video className="video-container" controls playsInline>
				<source src={url} type="video/mp4" />
			</video>
		);
	};

	return (
		<Modal open={isOpen} onClose={onClose}>
			<div className="view-media-modal-container">
				<Tooltip title="Close">
					<IconButton className="close-button" onClick={close}>
						<IoClose />
					</IconButton>
				</Tooltip>
				{renderMedia()}
			</div>
		</Modal>
	);
}
